<template>
    <section class="home-bed">
      <div class="img-bed">
        <black-bar title="退款">
        </black-bar>
      </div>
      <div class="content">
        <img src="../assets/img/noAccess/icon_success.png" alt="">
        <p class="content-success">退款成功</p>
        <p class="content-tip">{{count}}秒后自动跳转至待充值订单页面</p>
      </div>
      <button class="completeBtn" @click="complete">完成</button>
    </section>
  </template>
  
  <script>
  import blackBar from '@/components/blackBar'
  export default {
    name: 'refundSuccess',
    data () {
      return {
        count: 3,
        timer: null
      }
    },
    components: {
      blackBar
    },
    mounted () {
        this.countDown()
    },
    destroyed () {
      clearInterval(this.timer)
    },
    methods: {
        countDown() {
          let that = this
          this.timer = setInterval(() => {
            if (that.count == 0) {
              that.complete()
              return
            }
            that.count --
          }, 1000);
        },
        complete() {
          clearInterval(this.timer)
          this.$router.back()
        },
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .home-bed {
    // background: #eee;
    min-height: 100%;
    overflow: scroll;
    position: relative;
    text-align: center;
    background-color: #fff;
  }
  .img-bed {
    font-size: 0;
    margin-bottom: 12px;
    background: #fff;
    position: relative;
    width: 100%;
    // height: 320px;
    > div {
      position: absolute;
      margin: 0 auto;
      width: 100%;
      padding: 20px 0;
      text-align: center;
      background-color: #666;
    }
    img {
      width: 100%;
    }
  }
  .content {
    margin-top: 112px;
    img {
        width: 100px;
        height: 100px;
    }
    .content-success {
        margin-top: 26px;
        color: #333;
        font-size: 40px;
        font-weight: 600;
    }
    .content-tip {
        margin-top: 18px;
        color: #666;
        font-size: 26px;
    }
  }
  button {
    position: absolute;
    bottom: 80px;
    left: 4%;
    width: 92%;
    height: 108px;
    border-radius: 54px;
    background-color: #3F8AF7;
    color: #fff;
    font-size: 32px;
    border: 0;
  }
  </style>
  